Inspired by https://github.com/vue-a11y/vue-focus-loop

<template>
  <div :class="{ hidden: !isActive }">
    <template v-if="isActive">
      <div tabindex="0" aria-hidden="true" @focus="handleFocusStart" />
      <div ref="focusTrap">
        <slot />
      </div>
      <div tabindex="0" aria-hidden="true" @focus="handleFocusEnd" />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, watch } from 'vue'

const props = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
})

const focusableElementsSelector = [
  ...['input', 'select', 'button', 'textarea'].map(
    (field) => `${field}:not([disabled])`,
  ),
  'a[href]',
  'video[controls]',
  'audio[controls]',
  '[tabindex]:not([tabindex^="-"])',
  '[contenteditable]:not([contenteditable="false"])',
].join(',')

const focusTrap = ref(null)
const prevFocusedElement = ref(null)

function init() {
  nextTick(() => {
    if (props.isActive) {
      prevFocusedElement.value = document.activeElement
      focusFirst()
    } else {
      prevFocusedElement.value && prevFocusedElement.value.focus()
    }
  })
}
function focusFirst() {
  const elements = getFocusableElements()
  if (elements.length) {
    // give enough time to open the modal
    setTimeout(() => elements[0].focus(), 200)
  }
}
function getFocusableElements() {
  const focusableElements = focusTrap.value.querySelectorAll(
    focusableElementsSelector,
  )
  if (focusableElements && focusableElements.length) {
    return focusableElements
  }
  return []
}
function handleFocusStart() {
  const elements = getFocusableElements()
  if (elements.length) {
    elements[elements.length - 1].focus()
  }
}
function handleFocusEnd() {
  const elements = getFocusableElements()
  if (elements.length) {
    elements[0].focus()
  }
}

onMounted(() => {
  init()
})

watch(
  () => props.isActive,
  () => {
    init()
  },
)
</script>
